import { Link } from 'wouter';

export function Logo({ size = 'md' }: { size?: 'md' | 'lg' }) {
  const box = size === 'lg' ? 'w-7 h-7 text-sm' : 'w-[22px] h-[22px] text-xs';
  const text = size === 'lg' ? 'text-lg' : 'text-[15px]';
  return (
    <Link href="/" className="inline-flex items-center gap-2 font-semibold tracking-[-0.2px]">
      <span
        className={[
          'bg-fg rounded-md inline-flex items-center justify-center font-bold text-accent',
          box,
        ].join(' ')}
      >
        A
      </span>
      <span className={text}>
        anuleaza<span className="text-accent">.</span>ro
      </span>
    </Link>
  );
}
